/**
 * Safely parses a JSON string and returns a default value if parsing fails
 * @param jsonString - The JSON string to parse
 * @param defaultValue - The default value to return if parsing fails (defaults to empty object)
 * @returns The parsed JSON object or the default value
 */
export function parseJSONSafely<T = Record<string, any>>(
  jsonString: string | null | undefined,
  defaultValue: T = {} as T
): T {
  if (!jsonString) {
    return defaultValue;
  }

  try {
    return JSON.parse(jsonString) as T;
  } catch (e) {
    return defaultValue;
  }
}
